module.exports = "<section>\n  <h2 class=\"underlined-title\">\n    Contact us\n  </h2>\n</section>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/screens/guest/screens/contact/contact.html
// module id = 364
// module chunks = 0